// src/components/ProgressBar.tsx

import React from 'react';
import { motion } from 'framer-motion';

interface ProgressBarProps {
  current: number;
  total: number;
  percentage: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, percentage }) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          {current} of {total} questions completed
        </span>
        <span className="text-sm font-medium text-blue-600">
          {percentage}%
        </span>
      </div>
      <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-blue-500 to-blue-600"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />
      </div>
      <div className="mt-2 text-xs text-gray-500 text-center">
        ⏱️ Estimated time remaining: {Math.max(1, Math.ceil((total - current) * 0.5))} minutes
      </div>
    </div>
  );
};

export default ProgressBar;
